export default __webpack_public_path__ + "static/media/logout-icon-active.c26d70c3.svg";